import Header from "../Header";
import Button from "../Button";

import { alertUser } from 'logic/eventBeforeunload';

import {
  PageWrapper,
  Container,
  Wrapper,
  Icon,
  Title,
  Desc,
} from './style'

export default function ResultPage({
  header,
  icon,
  titleText='',
  des='',
  buttonText='ตกลง',
  onClick,
}) {
  
  return (
    <PageWrapper>
      {header && <Header text={header} />}
      <Container>
        <Wrapper>
          {icon && (
            <Icon>
              <img src={icon} alt={titleText} />
            </Icon>
          )}

          <Title>{titleText}</Title>

          {des && <Desc>{des}</Desc>}
          {onClick && (
            <Button onClick={onClick}>
              {buttonText}
            </Button>
          )}
          
        </Wrapper>
      </Container>
    </PageWrapper>
  )
}
